import { PremiumMonthlyInfo, PremiumSummaryInfo } from '@cms-max/medicare-api-sdk'

import beneMessages from './beneMesages.json'

// TODO - add text replacements for variables in bene messages
const defaultCurrentMonthlyPremiumInfo: PremiumMonthlyInfo = {
  date: {
    year: 2023,
    month: 6,
    full: 'June 2023'
  },
  isCurrent: true,
  partA: {
    amount: 0,
    lateEnrollmentPenalty: 0
  },
  partB: {
    amount: 164.90,
    irmaaAmount: 164.80,
    lateEnrollmentPenalty: 0,
    maPlanPayment: 0
  },
  partD: {
    irmaaAmount: 31.50
  },
  total: 361.20
}

export const premiumSummaryInfoScenarios = {
  eligibleMonthlyNoEasy: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[1],
        es: beneMessages.msg1[1]
      },
      lastBill: {
        en: beneMessages.msg3[0],
        es: beneMessages.msg3[0]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      lastPayment: {
        en: beneMessages.msg4,
        es: beneMessages.msg4
      },
      paymentReceived: {
        en: beneMessages.msg41,
        es: beneMessages.msg41
      }
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligibleMonthlyNoEasyPaid: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[1],
        es: beneMessages.msg1[1]
      },
      lastBill: {
        en: beneMessages.msg3[0],
        es: beneMessages.msg3[0]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      lastPayment: {
        en: beneMessages.msg4,
        es: beneMessages.msg4
      },
      paymentReceived: {
        en: beneMessages.msg41,
        es: beneMessages.msg41
      },
      paymentProcessed: {
        en: beneMessages.msg11,
        es: beneMessages.msg11
      },
      noPremiumOwed: {
        en: beneMessages.msg13,
        es: beneMessages.msg13
      }
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligibleMonthlyNoMsg3: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[1],
        es: beneMessages.msg1[1]
      },
      lastPayment: {
        en: beneMessages.msg4,
        es: beneMessages.msg4
      },
      paymentReceived: {
        en: beneMessages.msg41,
        es: beneMessages.msg41
      },
      lastBill: undefined
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligibleMonthlyNewPayer: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[1],
        es: beneMessages.msg1[1]
      },
      lastBill: {
        en: beneMessages.msg3[0],
        es: beneMessages.msg3[0]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      lastPayment: undefined,
      paymentReceived: undefined
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligibleQuarterly: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[0],
        es: beneMessages.msg1[0]
      },
      lastBill: {
        en: beneMessages.msg3[0],
        es: beneMessages.msg3[0]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      lastPayment: {
        en: beneMessages.msg4,
        es: beneMessages.msg4
      },
      paymentReceived: {
        en: beneMessages.msg41,
        es: beneMessages.msg41
      }
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligiblePartialSSA: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[3],
        es: beneMessages.msg1[3]
      },
      lastBill: {
        en: beneMessages.msg3[0],
        es: beneMessages.msg3[0]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      lastPayment: {
        en: beneMessages.msg4,
        es: beneMessages.msg4
      },
      paymentReceived: {
        en: beneMessages.msg41,
        es: beneMessages.msg41
      }
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligibleEasyPay: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: true,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[2],
        es: beneMessages.msg1[2]
      },
      lastBill: {
        en: beneMessages.msg3[2],
        es: beneMessages.msg3[2]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      lastPayment: {
        en: beneMessages.msg4,
        es: beneMessages.msg4
      },
      paymentReceived: {
        en: beneMessages.msg41,
        es: beneMessages.msg41
      }
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  eligibleThirdPartyPayer: {
    isDirectBillingEligible: true,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[0],
        es: beneMessages.msg1[0]
      },
      paymentDue: {
        en: beneMessages.msg2[0],
        es: beneMessages.msg2[0]
      },
      partAThirdParty: {
        en: beneMessages.msg8[1],
        es: beneMessages.msg8[1]
      },
      lastPayment: undefined,
      lastBill: undefined
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  notEligibleThirdPartyPayer: {
    isDirectBillingEligible: false,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: undefined,
      lastBill: {
        en: beneMessages.msg3[3],
        es: beneMessages.msg3[3]
      },
      partAThirdParty: {
        en: beneMessages.msg8[1],
        es: beneMessages.msg8[1]
      },
      partBThirdParty: {
        en: beneMessages.msg8[2],
        es: beneMessages.msg8[2]
      },
      lastPayment: undefined
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  notEligibleSSA: {
    isDirectBillingEligible: false,
    isDirectBillingDeferred: false,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: {
        en: beneMessages.msg1[6],
        es: beneMessages.msg1[6]
      },
      lastBill: {
        en: beneMessages.msg3[3],
        es: beneMessages.msg3[3]
      },
      lastPayment: undefined
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo,
  notEligibleDeferred: {
    isDirectBillingEligible: false,
    isDirectBillingDeferred: true,
    isEasyPayEnrolled: false,
    isPartDIRMAA: false,
    isPartCOrD: false,
    beneMessages: {
      howYouPay: undefined,
      lastBill: {
        en: beneMessages.msg3[0],
        es: beneMessages.msg3[0]
      },
      lastPayment: undefined
    },
    currentMonthlyPremiumInfo: defaultCurrentMonthlyPremiumInfo
  } as PremiumSummaryInfo
} as const

export default premiumSummaryInfoScenarios
